var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.loading)?_c('pt-sample-status',{attrs:{"status":_vm.status,"id":_vm.id,"data":_vm.data,"order":_vm.order,"reasonOptions":_vm.reasonOptions,"isAbnormal":_vm.isAbnormal,"bill":_vm.bill}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }